import classNames from '@/lib/misc/classNames';
import Image from 'next/image';
import confetti from 'canvas-confetti';
import Link from 'next/link';
import MobileMenu from '@/components/shared/MobileMenu';
import { Button } from '@/components/ui/button';
import { useEffect } from 'react';
import { useGetUsernames } from '@/hooks/auth/useGetUsernames';
import useGetUserProfileInfo from '@/hooks/auth/useGetUserProfileInfo';
import { useIsMobile } from '@/hooks/utilities/use-mobile';
export default function SwapSuccess({
  swapLoading,
  swapResult,
  setIsConfirmationDialogOpen,
  setSwapResult,
  setFromAssets,
  setToAssets
}) {
  function handleReset() {
    setSwapResult({
      error: '',
      time: 0
    });
    setFromAssets([]);
    setToAssets([]);
    setIsConfirmationDialogOpen(false);
  }
  useEffect(() => {
    confetti({
      particleCount: 250,
      spread: 60
    });
  }, []);
  const {
    firstName
  } = useGetUserProfileInfo();
  const isMobile = useIsMobile();
  return <div className={classNames('h-[100vh] md:h-fit bg-genius-cream-foreground z-80 relative rounded-b-3xl bg-genius-indigo', {
    invisible: swapLoading,
    visible: !swapLoading
  })} data-sentry-component="SwapSuccess" data-sentry-source-file="SwapSuccess.tsx">
      <div className='ta-c w-full m-auto px-4 text-genius-cream'>
        <div className='px-4  h-[400px] md:h-fit pt-14'>
          <Image className='mt-[20%] m-auto w-[60px] h-[63px] ' alt='confirmation' src='/static/images/success.png' width={100} height={100} data-sentry-element="Image" data-sentry-source-file="SwapSuccess.tsx" />

          <h1 className='font-normal text-[24px] text-genius-cream mt-10'>
            Way to go, {firstName}.
          </h1>

          <p className='text-sm mt-4 text-genius-cream/50'>Order Submitted!</p>
        </div>
        <div className='fixed bottom-20 w-[100%] md:w-full md:static left-0 right-0 mx-auto justify-center ta-c px-2'>
          <Button onClick={() => handleReset()} className='h-[56px] rounded-full bg-genius-blue md:hover:bg-genius-blue text-genius-cream w-[100%] mx-auto mt-[30px] mb-1' data-sentry-element="Button" data-sentry-source-file="SwapSuccess.tsx">
            {isMobile ? 'Make Another Trade' : 'Close'}

          </Button>

          <Link className='rounded-[90%] mx-auto' href={`/history?order_id=${swapResult?.order_id}`} data-sentry-element="Link" data-sentry-source-file="SwapSuccess.tsx">
            <Button className='w-[100%] rounded-full h-[56px] text-genius-cream' variant='purple' data-sentry-element="Button" data-sentry-source-file="SwapSuccess.tsx">
              View Order
            </Button>
          </Link>
          {isMobile && <Link className='rounded-[90%] mx-auto' href={`/home`}>
              <Button variant='pink' className='h-[56px] rounded-full w-[100%] mx-auto mt-1'>
                Go Home
              </Button>
            </Link>}
        </div>
      </div>
      <MobileMenu data-sentry-element="MobileMenu" data-sentry-source-file="SwapSuccess.tsx" />
    </div>;
}